import type { ReadConfig } from 'api-read-hook';
import type { HydraCollection } from '../../types';

import { useApiRead } from 'api-read-hook';

export type V_All = {
  '@id': string;
  '@type': 'Recipe';
  id: string;
  name: string;
  description: string | null;
  slug: string | null;
};

export function useReadCollection(options?: ReadConfig) {
  return useApiRead<HydraCollection<V_All>>(`/recipes`, options);
}
